import { render, staticRenderFns } from "./SuketRanap.vue?vue&type=template&id=332c68e6&scoped=true&"
import script from "./SuketRanap.vue?vue&type=script&lang=ts&"
export * from "./SuketRanap.vue?vue&type=script&lang=ts&"
import style0 from "./SuketRanap.vue?vue&type=style&index=0&id=332c68e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c68e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VIcon,VProgressCircular,VSpacer,VTab,VTabItem,VTabs})
